import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes/routesAdm";
import history from "./services/history";
import { AuthProvider } from "./config/Context/AuthContext";
import { PermissoesProvider } from "./config/Context/PermissoesContext";
import "./App.css";
import { CadastroProvider } from "./config/Context/CadastroContext";
import { LoginProvider } from "./config/Context/LoginContext";
import { RelatoriosProvider } from "./pages/Relatorios/RelatoriosContext";
import { ExportRelatorioProvider } from "./components/BotaoRelatorio/ExportRelatorioContext";
import { useEffect } from "react";
import { attachInputGuards } from "./utils/inputGuards";
import { PreviaInssProvider } from "./pages/PreviaINSS/PreviaInssContext";

function App() {
  const limpaCache = () => {
    const hasReload = localStorage.getItem("reload");
    if (!hasReload) {
      localStorage.setItem("reload", true);
      window.location.reload(true);
    }
  };
  useEffect(() => {
    limpaCache();
  }, []);
  // Attach global input guards once
  useEffect(() => {
    const detach = attachInputGuards(document);
    return () => detach && detach();
  }, []);
  return (
    <div className="container__global">
      <LoginProvider>
        <AuthProvider>
          <PermissoesProvider>
          <CadastroProvider>
            <RelatoriosProvider>
              <ExportRelatorioProvider>
                <PreviaInssProvider>
                  <Router navigator={history} location={history.location}>
                    <Routes />
                  </Router>
                </PreviaInssProvider>
              </ExportRelatorioProvider>
            </RelatoriosProvider>
          </CadastroProvider>
          </PermissoesProvider>
        </AuthProvider>
      </LoginProvider>
    </div>
  );
}

export default App;
